import { copyText } from '@/lib/clipboard'
import { useCallback } from 'react'
import useDefaultToast from './useDefaultToast'

export default function useCopyText() {
  const toast = useDefaultToast()

  return useCallback(
    async (text: string) => {
      const copied = await copyText(text)
      toast.show(copied ? '复制成功' : '复制失败，请手动复制')
    },
    [toast]
  )
}
